module.exports = __webpack_public_path__ + "static/media/TD.3ca8c5e1.svg";